import { MdsIconKind } from "@/design-system/components/icon/types";
import { ButtonProps } from "react-aria-components";

export enum MDSCardSlotName {
  RightAddon = "rightAddon",
  Content = "content",
}

export interface IMDSCardProps extends ButtonProps {
  /**
   * Icon kind to display
   */
  mdsIcon?: MdsIconKind;
  /**
   * Card title
   */
  title?: string;
  /**
   * Card description text
   */
  description?: string;

  children: React.ReactNode;
}
